































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import DrivewealthDocuments from "@/shared/components/investments/drivewealth/DrivewealthDocuments.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import DrivewealthNavigation from "@/shared/components/investments/drivewealth/DrivewealthNavigation.vue";
import AccountTypeSubheader from "@/employee/components/investments/drivewealth/AccountTypeSubheader.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  components: {
    DrivewealthDocuments,
    DrivewealthNavigation,
    RiskDisclaimer,
    AccountTypeSubheader
  }
})
export default class DrivewealthDocumentsPage extends Vue {
  @Prop() accountId: number;
  @Prop() pageNumber: number;
  @Prop() hideNav: boolean;
  @Prop() routeToPages: (page: number) => Location;
  @Prop() routeToDrivewealthDocuments: (pageNumber: number) => Location;
  @Prop() routeToDrivewealthDocumentsV2: (accountId: number, pageNumber: number) => Location;

  drivewealthStore = useDrivewealthStore();

  mounted (): void {
    this.drivewealthStore.getAccountSummaryV2({ username: null, partnerId: null, dwAccountId: this.accountId });
  }

  get displayPageHeader (): boolean {
    const accountSummary = this.drivewealthStore.accountSummaryById(this.accountId);
    return accountSummary && !this.hideNav;
  }
}
